import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';

import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import authenticationProvider from '../../../utilities/authentication/authenticationProvider';

import {
  initBlock,
  resetBlock,
  setPopUp,
  goToPage,
  reportAnalytics,
  setIsBackNavigationDone,
  setIsListenerAdded,
  reportDWH
} from './PremiumPackagesCatalogSlice';
import { redirectToLoginAsync, premiumPackageActionAsync, checkInfo, getCatalogAsync } from './premiumPackagesCatalogAsyncThunk';
import PremiumPackagePopup from './Partials/popup/premiumPackagePopup';
import Loader from './Partials/loader/loader';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { setSelectedService } from '../../Page/SelfCarePage/SelfCareSlice';

//pages
import SubscriberListPage from './Pages/SubscriberListPage';
import PackagesPage from './Pages/PackagesPage';
import PackageBasicPage from './Pages/PackageBasicPage';
import AllPackagesInstalledPage from './Pages/AllPackagesInstalledPage';
import PackagesWorldPage from './Pages/PackagesWorldPage';
import PackageRoutesPage from './Pages/PackageRoutesPage';
import PackageExistPage from './Pages/PackageExistPage';
import ProvisioningPage from './Pages/ProvisioningPage';
import ErrorPage from './Pages/ErrorPage';
import Config from 'app/Config';

const PremiumPackagesCatalog = (props) => {
  let currentView = null;
  console.log('PremiumPackagesCatalog render with props: ', props);
  //--------------- useEffect ---------------
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.initBlock({ premiumPackagesCatalogBlock: props.iContent });

      const params = new URLSearchParams(window.location.search);
      const packageid = params.get('packageid');
      if (packageid) {
        props.reportDWH({ actionType: 'NewsletterLinkEntry', status: 'Ongoing', messageText: 'NewsletterLinkDisplayed' });
      }
    }
    return () => {
      if (runSideEffects()) {
        props.resetBlock();
      }
    };
  }, []);

  function handlePopState(event) {
    // The user clicked the back button
    if (!window.location.hash && !props.isBackNavigationDone) {
      window.removeEventListener('popstate', handlePopState);
      window.history.go(-1);
    }
  }

  useEffect(() => {
    if (!props.isListenerAdded) {
      window.addEventListener('popstate', handlePopState);
      props.setIsBackNavigationDone(false);
      props.setIsListenerAdded(true);
    }
  }, [window.location.hash]);

  useEffect(() => {
    if (props._authentication.isAuthenticateFinish) {
      // if (props._authentication.loginData.isFullAuthenticated || props._authentication.loginData.isOtpExtendedAuthenticated) {
      //   props.checkInfo();
      // } else {
      //   authenticationProvider.redirectToLogin(location.pathname, '');
      // }
      props.checkInfo();
    }
  }, [props._authentication.isAuthenticateFinish]);


  useClearStateResetFlag();

  switch (props.page) {
    case 'subscriberListPage':
      currentView = <SubscriberListPage />;
      break;
    case 'allPackagesInstalledPage':
      currentView = <AllPackagesInstalledPage />;
      break;
    case 'packagesPage':
      currentView = <PackagesPage context={props.context} />;
      break;
    case 'packageBasicPage':
      currentView = <PackageBasicPage context={props.context} />;
      break;
    case 'packagesWorldPage':
      currentView = <PackagesWorldPage context={props.context} />;
      break;
    case 'packageRoutesPage':
      currentView = <PackageRoutesPage context={props.context} />;
      break;
    case 'packageExistPage':
      currentView = <PackageExistPage context={props.context} />;
      break;
    case 'provisioningPage':
      currentView = <ProvisioningPage context={props.context} />;
      break;
    case 'errorPage':
      currentView = <ErrorPage />;
      break;
  }

  function handleClosePopUp(isOnlyClosePopUp, btnText) {
    props.setPopUp({ isDisplay: false, type: '' });
    if (props.popup.type == 'alertBeforeRemovePackage' && btnText) {
      props.reportAnalytics({
        eventCategory: 'premium_packages',
        eventAction: 'click_10',
        eventLabel: btnText,
      });
    }
    if (props.popup.type == 'alert' && btnText) {
      props.reportAnalytics({
        eventCategory: 'premium_packages',
        eventAction: 'click_14',
        eventLabel: 'element_14',
      });
    }

    if (isOnlyClosePopUp) {
      switch (props.popup.type) {
        case 'provisioningFailed':
          props.goToPage('packagesPage');
          setTimeout(() => {
            props.getCatalogAsync();
          }, '2000');
          break;
        case 'hboChangeSuccess':
          if (btnText === 'ל-HBO Max') {
            props.context.navigateTo(Config.redirectToHboUrl);
          } else {
            props.showAppLoader();
            props.goToPage('packagesPage');
            props.getCatalogAsync();
          }
          break;
        case 'disneyChangeSuccess':
          if (btnText === 'לדיסני+') {
            props.context.navigateTo(Config.redirectToDisneyUrl);
          } else {
            props.showAppLoader();
            props.goToPage('packagesPage');
            props.getCatalogAsync();
          }
          break;
      }
      return;
    }

    switch (props.popup.type) {
      case 'installedSuccess':
        props.showAppLoader();
        if (props.isCameFromSelfCarePage) {
          window.history.go(-1);
        } else {
          props.goToPage('packagesPage');
          setTimeout(() => {
            props.getCatalogAsync();
          }, '5000');
        }
        break;
      case 'installedFailed':
        break;
      case 'alertBeforeRemovePackage':
      case 'alertBeforeRemoveBundlePackage':
        props.premiumPackageActionAsync({ action: 'remove' });
        break;
      case 'removedSuccess':
        props.showAppLoader();
        if (props.isCameFromSelfCarePage) {
          window.history.go(-1);
        } else {
          props.goToPage('packagesPage');
          setTimeout(() => {
            props.getCatalogAsync();
          }, '5000');
        }
        break;
      case 'removedFailed':
        break;
      case 'alert':
        break;
      case 'provisioningFailed':
        props.showAppLoader();
        props.goToPage('packagesPage');
        props.getCatalogAsync();
        break;
      case 'hboChangeSuccess':
        if (btnText === 'ל-HBO Max') {
          props.context.navigateTo(Config.redirectToHboUrl);
        } else {
          props.showAppLoader();
          props.goToPage('packagesPage');
          props.getCatalogAsync();
        }
        break;
      case 'disneyChangeSuccess':
        if (btnText === 'לדיסני+') {
          props.context.navigateTo(Config.redirectToDisneyUrl);
        } else {
          props.showAppLoader();
          props.goToPage('packagesPage');
          props.getCatalogAsync();
        }
        break;
      case 'hboChangePlanSuccess':
      case 'hboChangePlanFailed':
      case 'disneyChangePlanSuccess':
      case 'disneyChangePlanFailed':
        props.showAppLoader();
        props.goToPage('packagesPage');
        props.getCatalogAsync();
        break;
      default:
        break;
    }
  }

  function handleClickCallToService() {
    if (props.popup.type == 'removedFailed') {
      props.reportAnalytics({
        eventCategory: 'premium_packages',
        eventAction: 'click_11',
        eventLabel: 'element_11',
      });
    }
  }

  return (
    <>
      {currentView}
      <PremiumPackagePopup popupInfo={props.popup} closePopUp={handleClosePopUp} onClickCallToService={handleClickCallToService} />
      {props.loader.isDisplay && <Loader title={props.loader.title} />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.premiumPackagesCatalog.page,
    popup: state.premiumPackagesCatalog.popup,
    loader: state.premiumPackagesCatalog.loader,
    isBackNavigationDone: state.premiumPackagesCatalog.isBackNavigationDone,
    isListenerAdded: state.premiumPackagesCatalog.isListenerAdded,
    isCameFromSelfCarePage: state.premiumPackagesCatalog.isCameFromSelfCarePage,
    _authentication: state.authentication
  };
};

const mapDispatchToProps = {
  initBlock,
  resetBlock,
  getCatalogAsync,
  setIsBackNavigationDone,
  setIsListenerAdded,
  premiumPackageActionAsync,
  checkInfo,
  setPopUp,
  goToPage,
  redirectToLoginAsync,
  reportAnalytics,
  showAppLoader,
  hideAppLoader,
  setSelectedService,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(PremiumPackagesCatalog);
